import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import {
  loadUnitsSettings,
  saveUnitsSettings,
  UNIT_SYSTEMS,
} from '../../utils/unitsSettingsStore.js';

const Section = styled.div`
  flex-shrink: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
`;

const Header = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 10px 16px;
  border: none;
  background: rgba(0, 0, 0, 0.02);
  font-size: 12px;
  font-weight: 700;
  color: #444;
  cursor: pointer;
`;

const Body = styled.div`
  padding: 10px 16px 14px;
  font-size: 12px;
  color: #4b5563;
`;

const Row = styled.label`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 8px;

  &:first-child {
    margin-top: 0;
  }
`;

const Select = styled.select`
  height: 30px;
  padding: 0 8px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 12px;
  background: #fff;
`;

const Hint = styled.div`
  margin-top: 8px;
  font-size: 11px;
  color: #9ca3af;
  line-height: 1.45;
`;

export default function UnitsSettingsPanel({ projectId, onUnitsChange }) {
  const [open, setOpen] = useState(false);
  const [unitSystem, setUnitSystem] = useState(UNIT_SYSTEMS.IMPERIAL);
  const [lengthPrecision, setLengthPrecision] = useState(1);

  useEffect(() => {
    const saved = loadUnitsSettings(projectId);
    setUnitSystem(saved.unitSystem);
    setLengthPrecision(saved.lengthPrecision);
  }, [projectId]);

  const persist = (next) => {
    saveUnitsSettings(projectId, next);
    onUnitsChange?.(next);
  };

  return (
    <Section>
      <Header type="button" onClick={() => setOpen((v) => !v)}>
        <span>Units</span>
        <span>{open ? '▾' : '▸'}</span>
      </Header>
      {open && (
        <Body>
          <Row>
            <span>Display</span>
            <Select
              value={unitSystem}
              onChange={(e) => {
                const next = { unitSystem: e.target.value, lengthPrecision };
                setUnitSystem(next.unitSystem);
                persist(next);
              }}
            >
              <option value={UNIT_SYSTEMS.IMPERIAL}>Imperial (ft-in)</option>
              <option value={UNIT_SYSTEMS.METRIC}>Metric (m)</option>
            </Select>
          </Row>
          <Row>
            <span>Length precision</span>
            <Select
              value={lengthPrecision}
              onChange={(e) => {
                const next = {
                  unitSystem,
                  lengthPrecision: Number(e.target.value),
                };
                setLengthPrecision(next.lengthPrecision);
                persist(next);
              }}
            >
              <option value={0}>0 decimals</option>
              <option value={1}>1 decimal</option>
              <option value={2}>2 decimals</option>
            </Select>
          </Row>
          <Hint>
            Affects measurement readouts in the inspector. Scale calibration still drives real-world conversions.
          </Hint>
        </Body>
      )}
    </Section>
  );
}
